// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MediaGalleryHeader__container-de67fa {
  background: linear-gradient(180deg, #18191f 0%, rgba(24, 25, 31, 0) 100%);
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: var(--header-height);
  flex-shrink: 0;
  padding-inline-start: var(--gallery-view-padding);
  position: absolute;
  width: 100%;
  z-index: 1;
}

.MediaGalleryHeader__right-panel-b85e06 {
  display: flex;
}

.MediaGalleryHeader__message-info-panel-ec50d0 {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 300px;
  margin-inline-start: var(--gallery-view-padding);
  padding: 0px 16px;
  box-sizing: border-box;
}

.MediaGalleryHeader__controls-dd6fdd {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.MediaGalleryHeader__control-f48409:not(:first-child) {
  margin-inline-start: 16px;
}

.MediaGalleryHeader__rotated-control-b128ba {
  transform: rotate(180deg);
}

.MediaGalleryHeader__divider-cc26ce {
  position: absolute;
  inset-inline-start: 0px;
  top: 50%;
  height: 40px;
  border-left: 1px solid var(--addition-50_15);
  transform: translateY(-50%);
}`, "",{"version":3,"sources":["webpack://./src/main/components/MediaGallery/MediaGalleryHeader/MediaGalleryHeader.style.m.css"],"names":[],"mappings":"AAAA;EACE,yEAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,cAAA;EACA,iDAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gDAAA;EACA,iBAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,4CAAA;EACA,2BAAA;AACF","sourcesContent":[".container {\n  background: linear-gradient(180deg, #18191f 0%, rgba(24, 25, 31, 0) 100%);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: var(--header-height);\n  flex-shrink: 0;\n  padding-inline-start: var(--gallery-view-padding);\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n\n.right-panel {\n  display: flex;\n}\n\n.message-info-panel {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 300px;\n  margin-inline-start: var(--gallery-view-padding);\n  padding: 0px 16px;\n  box-sizing: border-box;\n}\n\n.controls {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n}\n\n.control:not(:first-child) {\n  margin-inline-start: 16px;\n}\n\n.rotated-control {\n  transform: rotate(180deg);\n}\n\n.divider {\n  position: absolute;\n  inset-inline-start: 0px;\n  top: 50%;\n  height: 40px;\n  border-left: 1px solid var(--addition-50_15);\n  transform: translateY(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MediaGalleryHeader__container-de67fa`,
	"right-panel": `MediaGalleryHeader__right-panel-b85e06`,
	"rightPanel": `MediaGalleryHeader__right-panel-b85e06`,
	"message-info-panel": `MediaGalleryHeader__message-info-panel-ec50d0`,
	"messageInfoPanel": `MediaGalleryHeader__message-info-panel-ec50d0`,
	"controls": `MediaGalleryHeader__controls-dd6fdd`,
	"control": `MediaGalleryHeader__control-f48409`,
	"rotated-control": `MediaGalleryHeader__rotated-control-b128ba`,
	"rotatedControl": `MediaGalleryHeader__rotated-control-b128ba`,
	"divider": `MediaGalleryHeader__divider-cc26ce`
};
module.exports = ___CSS_LOADER_EXPORT___;
